import React from 'react';

interface NewChatIconProps {
  className?: string;
  size?: number;
}

const NewChatIcon: React.FC<NewChatIconProps> = ({ className, size = 24 }) => {
  return (
    <svg 
      xmlns="http://www.w3.org/2000/svg" 
      viewBox="0 0 48 48"
      width={size}
      height={size}
      className={className}
      fill="currentColor"
    >
      <g>
        <path d="M41,5H15c-1.09998,0-2,.89996-2,2v8h20c2.21002,0,4,1.78998,4,4v8h4c1.09998,0,2-.90002,2-2V7c0-1.10004-.90002-2-2-2Z"/>
        <circle cx="20" cy="28" r="1"/>
        <circle cx="12" cy="28" r="1"/>
        <path d="M33,17H7c-1.09998,0-2,.89996-2,2v18c0,1.09998.90002,2,2,2h9.5l2.70001,3.59998c.19.25.48999.40002.79999.40002s.60999-.15002.79999-.40002l2.70001-3.59998h9.5c1.09998,0,2-.90002,2-2v-18c0-1.10004-.90002-2-2-2ZM12,31c-1.65002,0-3-1.35004-3-3s1.34998-3,3-3,3,1.34998,3,3-1.34998,3-3,3ZM20,31c-1.65002,0-3-1.35004-3-3s1.34998-3,3-3,3,1.34998,3,3-1.34998,3-3,3ZM28,31c-1.65002,0-3-1.35004-3-3s1.34998-3,3-3,3,1.34998,3,3-1.34998,3-3,3Z"/>
        <circle cx="28" cy="28" r="1"/>
      </g>
    </svg>
  );
};

export default NewChatIcon;
